module.exports = __webpack_public_path__ + "img/news-back.96872231.png";